<template lang="html">
  <div class="eb-pt-row-login">
    <div class="row justify-content-md-center mt-5">
      <div :class="formContainerClass">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <div>
              <h4 class="text-center mb-4 mt-4">
                Forgot Password
              </h4>
              <form>
                <p>Enter the email that you signed up with and you will receive instructions on how to reset your password.</p>
                <div class="form-group mt-4 mb-4">
                  <label
                    for="Email"
                    style="display:none;"
                  >Email</label>
                  <input
                    id="Email"
                    v-model="email_receive"
                    type="email"
                    class="form-control"
                    placeholder="Email"
                  >
                  <div class="message_error_login email_error">
                    {{ validation.firstError('email_receive') }}
                  </div>
                </div>
                <div
                  v-show="serverMessage !== ''"
                  class="form-group mt-4 mb-4"
                >
                  <div class="text-danger">
                    {{ serverMessage }}
                  </div>
                </div>
                <div class="form-group mt-4">
                  <div class="row justify-content-md-center">
                    <div class="col-md-8">
                      <button
                        id="btnSubmit"
                        type="button"
                        class="btn btn-block gf-driver-button-color gf-driver-background-bg"
                        @click="submit_form"
                      >
                        <span class="primary-text">Submit</span>
                      </button>
                    </div>
                  </div>
                </div>
                <br>
              </form>
            </div>
          </div>
          <div class="col-md-12 eb-bd-top">
            <p class="d-inline pl-5">
              Try Again?
            </p>
            <p class="d-inline pr-5 float-right">
              <a href="javascript:;" @click="router().show('login', { email_receive: email_receive })">
                Log in
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import forgetPasswordInitializer from './forgetPasswordInitializer.vue';

export default {
  name: 'ForgetPassword',
  mixins:[forgetPasswordInitializer],
  props: ['formContainerClass'],
  mounted: function() {
    if (this.router().getRouteParams('userEmail'))
      this.email_receive = this.router().getRouteParams('userEmail')
  }
}
</script>

<style lang="css">
</style>
